import { Item } from "types/Item";

export const send: Item[] = [];
